import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { startAddExpenseAccount } from '../../../actions/expenseAccountActions';
import ExpenseAccountForm from './ExpenseAccountForm';

export class AddExpenseAccountPage extends Component {

  onFormActionSubmit = (expenseAccount) => {
    this.props.startAddExpenseAccount(expenseAccount);
    // this.props.history.push('/cashier');
  };

  render() {
    return (
      <div>
        <Typography variant="display1" gutterBottom>
          Add Expense Account
        </Typography>
        <ExpenseAccountForm
          data={this.props.expense_accounts}
          editMode={false}
          onFormActionSubmit={this.onFormActionSubmit}
        />
      </div>
    );
  }
}

const mapStateToProps = expense_accounts => {
  return { expense_accounts };
};

const mapDispatchToProps = (dispatch) => ({
    startAddExpenseAccount: (expenseAccount) => dispatch(startAddExpenseAccount(expenseAccount))
});

export default connect(mapStateToProps, mapDispatchToProps)(AddExpenseAccountPage);



// WEBPACK FOOTER //
// ./src/components/admin/expenseAccounts/AddExpenseAccountPage.js